import type { FC, ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import { useDownloadManager } from 'src/components/downloadManager/DownloadManagerContext';
import { useMyFollowUpFilters } from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/hooks';

interface MyFollowUpContextValue {
  downloadAll: () => void;
}

const MyFollowUpContext = createContext<MyFollowUpContextValue>({
  downloadAll: () => {},
});

interface MyFollowUpContextProviderProps {
  children: ReactNode;
}

export const MyFollowUpContextProvider: FC<MyFollowUpContextProviderProps> = ({
  children,
}) => {
  const { poll } = useDownloadManager();
  const { dateRange, appliedFilters } = useMyFollowUpFilters();

  const downloadAll = () => {
    HttpService.get(apiPaths.MY_FOLLOW_UP.DOWNLOAD_ALL, {
      ...dateRange,
      ...appliedFilters,
    }).then(() => {
      poll();
    });
  };

  return (
    <MyFollowUpContext.Provider value={{ downloadAll }}>
      {children}
    </MyFollowUpContext.Provider>
  );
};

const useMyFollowUp = () => useContext(MyFollowUpContext);
export default useMyFollowUp;
